<script>
import api from "@/axios"
import Loader from "../components/loader"
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import UsuariosTable from './usuarios-table.vue'
import appConfig from "@/app.config"
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/usuarios_anim.json'
import { usuariosChart1, usuariosChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Usuários",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, UsuariosTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted usuarios-list_0')
    this.atualizaDataList()
  },
  data() {
    return {
      animationJson,
      title: 'Usuários',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Usuários',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      usuariosList: null,
      usersChart1: usuariosChart1,
      usersChart2: usuariosChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
    }
  },

  methods: {

    exportExcel(){
      console.log('exportExcel')
      const data = this.usuariosList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/usuarios`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data)
        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`)
        }else{
          this.usuariosList = res.data[0]
          this.title = `(${this.usuariosList.length}) Usuários`
          this.loadingList = false
          this.loadingGraph = false
        }
      })
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/usuario`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },


  },
}
</script>

<template>
  <Layout>
    <span class="float-end" style="z-index: 1000; position: absolute; top: 45px; right: 190px;">
      <Vue3Lottie :animationData="animationJson" :height="200" :width="200" />
    </span>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">

                  <router-link :to="`/usuario/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Novo Usuário
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <UsuariosTable v-if="!loadingList"
                            :usuariosList="usuariosList"
                            @deletareg="deletaReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>


    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Mensal</h4>
            <apexchart
                class="apex-charts"
                type="line"
                height="370"
                :series="usersChart1.series"
                :options="usersChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Equipes em Destaque</h4>
            <apexchart
                class="apex-charts"
                height="370"
                type="radialBar"
                dir="ltr"
                :series="usersChart2.series"
                :options="usersChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>
